import { CONFIG } from './config.js';

const CONVERSAO = new Set(['whatsapp_clique', 'site_clique']);

const envioPadrao = async (corpo, url) => {
  // sendBeacon sobrevive à navegação; é o certo para evento de conversão,
  // que acontece no instante em que a pessoa sai da página.
  if (navigator.sendBeacon?.(url, new Blob([corpo], { type: 'application/json' }))) return;
  await fetch(url, {
    method: 'POST', body: corpo, keepalive: true, mode: 'no-cors',
    headers: { 'Content-Type': 'application/json' },
  });
};

function idSessao() {
  try {
    const chave = 'memude-mapa-sessao';
    let id = sessionStorage.getItem(chave);
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(chave, id);
    }
    return id;
  } catch {
    // Navegação privada pode recusar o sessionStorage; um id de memória
    // serve igual e não pode derrubar a página.
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
}

export function criaTelemetria(deps = {}) {
  const {
    url = CONFIG.webhookEventos,
    envia = (corpo) => envioPadrao(corpo, url),
    intervaloMs = 10000,
  } = deps;

  const sessao = idSessao();
  const hoversContados = new Set();
  let fila = [];
  let timer = null;

  async function descarrega() {
    if (!url || fila.length === 0) return;
    const lote = fila;
    fila = [];
    clearTimeout(timer);
    timer = null;
    try {
      await envia(JSON.stringify({
        sessao,
        referenciador: typeof document !== 'undefined' ? document.referrer : '',
        utm: typeof location !== 'undefined' ? location.search : '',
        eventos: lote,
      }));
    } catch {
      // Telemetria nunca pode quebrar a página nem travar o lead.
    }
  }

  function registra(evento, dados = {}) {
    if (!url) return;
    // Um usuário passa o cursor sobre dezenas de marcadores por minuto. Sem
    // esta trava o n8n seria inundado e a métrica de interesse por imóvel
    // ficaria distorcida por quem só atravessou o mapa com o mouse.
    if (evento === 'marcador_hover') {
      if (hoversContados.has(dados.id)) return;
      hoversContados.add(dados.id);
    }
    fila.push({ evento, ...dados, quando: new Date().toISOString() });

    if (CONVERSAO.has(evento)) { descarrega(); return; }
    if (!timer) timer = setTimeout(descarrega, intervaloMs);
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') descarrega();
    });
  }

  return { registra, descarrega };
}
